
import React, {Component} from 'react';
import {connect} from 'react-redux'
import {compose} from 'redux'
import {withRouter} from 'react-router-dom'
import {Button,ButtonToolbar,DropdownButton,MenuItem,Nav,NavItem,Panel,Row,Col,FormControl,ControlLabel,FormGroup,InputGroup,Tabs,Tab,Modal} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import {Box} from 'reactjs-admin-lte'
import SWTWageDataGrid from './SWTWageDataGrid'
import SWTPartDataGrid from './SWTPartDataGrid'
import WorkdocStore from 'stores/WorkdocStore'
import {Checkbox} from 'react-icheck'
import ConfirmPopup from 'component/element/ConfirmPopup'
import NewDocFormModal from './NewDocFormModal'

import PurchaseOrderNewDocModal from 'view/po/PurchaseOrderNewDocModal'
import SWTStockOutPopup from '../SWTStockOutPopup';
import Moment from 'moment';
import IframeModal from 'component/element/IframeModal'
import ConfigFixingListModal from 'component/element/ConfigFixingListModal'
import Select from 'react-select'
import WorkDocCategoryModal from '../WorkDocCategoryModal'
import $ from 'jquery';
var NotificationSystem = require('react-notification-system');

const docNameConst = {invoice:'ใบแจ้งหนี้',receipt:'ใบเสร็จรับเงิน',taxinvoice:'ใบกำกับภาษี',cashbill:'บิลเงินสด',makerepairs:'ใบสรุปซ่อม'}
const defaultDocMenu = [
  {func:'quotation',title:'ใบเสนอราคา'},  
  {func:'divider',title:''},
  {func:'invoice',title:'ใบแจ้งหนี้'},
  {func:'receipt',title:'ใบเสร็จรับเงิน'},
  {func:'taxinvoice',title:'ใบกำกับภาษี'},  
  {func:'divider',title:''},
  {func:'exportstock',title:'ใบเบิกคลังสินค้า'},
  {func:'divider',title:''},
  {func:'purchaseorder',title:'ใบสั่งซื้อ'},
]          

const LOCK_EXPORT_CONFIG = {recordType:'lock_export',title:'สร้างรายการล็อกสินค้าในคลัง',saveButtonTitle:'ล็อกสต็อกและบันทึกรายการ',decreaseStockColumnTitle:'ล็อกสต็อก',remarkTitle:'ล็อกรายการสต๊อกโดยใบงานหมายเลข'}
const STOCK_OUT_CONFIG = {recordType:'export',title:'สร้างรายการเบิกคลังสินค้าในคลัง',saveButtonTitle:'ตัดสต็อกและบันทึกรายการ',decreaseStockColumnTitle:'ตัดสต็อก',remarkTitle:'ตัดรายการสต๊อกโดยใบงานหมายเลข'}


const DEFAULT_DAMAGE_CFG = {program_visible:false,wage_quantity_visible:false,
  part_cost_per_unit_visible:false,discount_visible:false,discount_sum_visible:false,part_first:false,
  service_code_visible:false,part_from_list_visible:false,part_from_list:[],init_no_of_wage:10,init_no_of_part:10,
  part_cost_require:false,hide_price_on_damage:false}
class SWTWorkDocDamage extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:true,loadingPart:false,partTab:'',errorShow:false,showNewDoc:false,docName:'',showWage:true,program:null,activeTab:0,presentTab:0,history:[],
    damageCfg:DEFAULT_DAMAGE_CFG, showStockOut:false,showDpDoc:false,showPoDoc:false,showGenDoc:false,genTitle:'',genDocType:'',genDocSName:'',genDocName:'',
    dataStockOut:[], dataPartlist:[], dataWagelist:[], promotionlist:[], see_more:{partlist:[],wagelist:[]}, displayBtnStockOutView: "none", btnDisabled: false, discountPart:[0,''], discountWage:[0,''], curDiscountPart:[0,''], curDiscountWage:[0,''], checkDiscount:false, displayDiscount:"none",
    discount_part:0, discount_wage:0, discountShow:false,showMissPartCost:false,depositlist:[],showDocW:false,showQOTable:false,categorys:[],showCate:false,showSymptom:false,symptomlist:[],
    docMenu:defaultDocMenu,stockOutConfig:STOCK_OUT_CONFIG,partFromList:[{'title':'ค่าอะไหล่','name':'stock_genpart',partList:[]}],showSetting:false,vat_type:'NON_VAT',remark:''
    }
  }


  componentDidMount(){    
    this.loadData(this.props.workNo)
    this.loadWageCategory()
    $('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open')) {
        $('.table-symptom').css( "overflow-x", "initial" );
      } else {
        $('.table-symptom').css( "overflow-x", "auto" );
      }  
    });
    if(this.props.onRef!==undefined){
      this.props.onRef(this)
    }
  }

  componentWillReceiveProps(newProps){
    if(this.props.workNo!==newProps.workNo){
      this.loadData(newProps.workNo)
    }
  }

  setPartList(partList){
    let data = partList.map((item,index)=>{
      // let amount = item.price_per_unit * item.quantity
      return {bfId:(item.bf_work_damage_id===undefined?item.bf_work_program_id:item.bf_work_damage_id),rowNo:item.seq,itemnum:item.itemnum,productCode:item.productcode,
        detail:item.detail,quantity:item.quantity,costPerUnit:(item.cost_per_unit===undefined?'0':item.cost_per_unit),pricePerUnit:item.price_per_unit,
        discountPercent:(item.discount_percent===undefined?'0':item.discount_percent),discountAmount:(item.discount_amount===undefined?'0':item.discount_amount),amount:(item.amount===undefined?item.part_cost:item.amount),
        exportStock:(item.export_stock_flag===undefined?'':item.export_stock_flag),exportQuantity:(item.export_quantity===undefined?'':item.export_quantity),partFrom:(item.part_from===undefined?'':item.part_from)}
    })
    return data
  }

  setWageList(wageList){
    let data = wageList.map((item,index)=>{
      // let amount = item.price_per_unit * item.quantity
      return {bfId:(item.bf_work_damage_id===undefined?item.bf_work_program_id:item.bf_work_damage_id),rowNo:item.seq,itemcode:(item.itemcode===undefined?item.itemnum:item.itemcode),servicecode:(item.servicecode===undefined?'':item.servicecode),
        detail:item.detail,quantity:item.quantity,pricePerUnit:item.price_per_unit,amount:(item.amount===undefined?item.wage_cost:item.amount),
        discountPercent:(item.discount_percent===undefined?'0':item.discount_percent),discountAmount:(item.discount_amount===undefined?'0':item.discount_amount)}
    })
    return data
  }

  loadWorkdocFixingList(workNo,completeFunc,errorFunc){
    if(this.props.onLoadData!==undefined){
      this.props.onLoadData(completeFunc,errorFunc)
    }else if(this.props.isProgramMode){
      WorkdocStore.loadWorkdocFixingListProgram(workNo,completeFunc,errorFunc)
    }else{
      WorkdocStore.loadWorkdocFixingList(workNo,completeFunc,errorFunc)
    }
  }

  loadData(workNo){
    if((workNo===''||workNo===undefined) && this.props.onLoadData===undefined){
      //Do nothing
      return;
    }
    this.setState({loadingPart:false})
    let {displayDiscount,checkDiscount,discountWage,discountPart,partTab} = this.state
    let partFromList = [{'title':'ค่าอะไหล่','name':'stock_genpart',partList:[]}] 
    this.loadWorkdocFixingList(workNo,(result)=>{
       let history = (typeof result.data.history !=='undefined')?result.data.history:[]
       
       let damageCfg = (result.data.damage_config===null)?DEFAULT_DAMAGE_CFG:Object.assign(DEFAULT_DAMAGE_CFG,result.data.damage_config)
       // console.log('damageCfg',damageCfg)
       let presentTab = 0
       history.forEach((item,index)=>{
          if(item.work_no===workNo){
            presentTab = index
          }
       })

      history.push({
        work_no:"",
        work_date:"",
        mileage:"",
        htmlContent:""
      })

      // let discount_part = 0
      // result.data.partlist.forEach((item,index)=>{
      //   discount_part += item.discount_amount
      // })
      // let discount_wage = 0
      // result.data.wagelist.forEach((item,index)=>{
      //   discount_wage += item.discount_amount
      // })

      // if (discount_part>0||discount_wage>0) {
      //   displayDiscount = ''
      //   checkDiscount = true
      //   discountWage[0] = ''
      //   discountWage[1] = discount_wage
      //   discountPart[0] = ''
      //   discountPart[1] = discount_part
      // }
      if (result.data.discount_part>0||result.data.discount_wage>0) {
        displayDiscount = ''
        checkDiscount = true
        discountWage[0] = ''
        discountWage[1] = result.data.discount_wage
        discountPart[0] = ''
        discountPart[1] = result.data.discount_part
      }

      if(result.data.vat_type!==undefined){
        this.setState({vat_type:result.data.vat_type})
      }
      if(result.data.remark!==undefined){
        this.setState({remark:result.data.remark})
      }
      
      if(damageCfg.part_from_list_visible){
        let {part_from_list} = damageCfg
        partFromList  = partFromList.concat(JSON.parse(JSON.stringify(part_from_list)))
        //[{title:'',name:'',list:[]},{title:'',name:'',list:[]}]      
        
        result.data.partlist.map((item,index)=>{
          let findex = partFromList.findIndex(o => o.name === item.part_from);          
          if(findex>=0){
            if(partFromList[findex].partList===undefined){
              partFromList[findex].partList = []
            }
            partFromList[findex].partList.push(item)
          }else{
            partFromList[0].partList.push(item)
          }          
          return item
        })
        
        //partFromList.unshift({'title':'ค่าอะไหล่','name':'stock_genpart',partList:partList})
        partFromList = partFromList.map((item,index)=>{
          if(item.partList!==undefined)
            item.partList =  this.setPartList(item.partList)
          else
            item.partList = []
          return item
        })
        
        partTab = 'tab-'+partFromList[0].name
        this.setState({partFromList:partFromList,partTab:partTab})
        
      }else{
         //this.refs.partDataGrid.getWrappedInstance().setPartList(this.setPartList(result.data.partlist))
         
      }
      //console.log('partFromList',partFromList,partTab)
      let partList =  this.setPartList(result.data.partlist)
      let wageList =  this.setWageList(result.data.wagelist)
      let docMenu = (result.data.doc_menu.length!==0)?result.data.doc_menu:defaultDocMenu
      docMenu  = JSON.parse(JSON.stringify(docMenu))
      if(result.data.extra_doc_menu!==undefined ){
        result.data.extra_doc_menu.forEach((item,index)=>{
          let insertIndex = -1;
          docMenu.forEach((ditem,dindex)=>{
            if(ditem.title===item.position_title){
              //Match
              if(item.position==='after'){
                insertIndex = dindex+1
              }else if(item.position==='before'){
                insertIndex = dindex
              }
            }
          })
          if(insertIndex>0){
            docMenu.splice(insertIndex, 0, item)        
          }
        }) 
      }
      const promotionlist = (result.data.promotionlist!==undefined)?result.data.promotionlist:[]
      this.setState({symptomlist:result.data.symptomlist,checkDiscount:checkDiscount,displayDiscount:displayDiscount,discount_part:result.data.discount_part,                
        discount_wage:result.data.discount_wage,loadingPart:true,dataPartlist:partList,dataWagelist:wageList,loading:false,program:result.data.program,
        activeTab:presentTab,presentTab:presentTab,damageCfg:damageCfg,history:history,docMenu:docMenu,depositlist:result.data.depositlist,promotionlist:promotionlist}) 
      this.calculateDiscount(discountPart,discountWage,partList,wageList,'init') 
    },()=>{


    })
  }

  loadWageCategory() {
    let categorys = []
    WorkdocStore.loadWageCategory((result)=>{
      categorys = result.data.map((item,index)=>{
        return {label:item.name,value:item.id}
      })
      this.setState({categorys:categorys})
    })
  }

  sortRowIndex(itemlist) {
    itemlist = itemlist.map((item,index)=>{
      item.rowNo = (index+1).toString()
      return item
    })
    return itemlist
  }

  onSaveClick(completeSaveFunc){
    let {program,discountPart,discountWage,sumAmtPart,sumAmtWage,totalAfterDis,vat_type,remark,displayDiscount,checkDiscount,damageCfg,partFromList} = this.state
    let wageList = this.refs.wageDataGrid.getWrappedInstance().getWageList()
    let partList = []
    if(damageCfg.part_from_list_visible){
      partFromList.map((item,index)=>{
        let list = this.refs['partDataGrid-'+item.name].getWrappedInstance().getPartList(item.name)
        partList =  partList.concat(list)
        return item
      })      
    }else{
      partList = this.refs.partDataGrid.getWrappedInstance().getPartList()
    }

    partList = this.sortRowIndex(partList)
    wageList = this.sortRowIndex(wageList)
    
    if(damageCfg.part_cost_per_unit_visible && damageCfg.part_cost_require){
      let found = partList.find(function(element) {
        return (element.description!=='' && element.costPerUnit*1===0)        
      });

      if(found){
        this.setState({showMissPartCost:true})
        return;
      }
    }
        
    this.setState({loading:true})    
    let totalBeforeVat = this.getTotalBeforeVat(vat_type,totalAfterDis)
    let totalVat = this.getTotalVat(vat_type,totalBeforeVat)
    let netTotal = totalBeforeVat + totalVat

    let postData = { wo: this.props.workNo, wage_list: wageList, part_list: partList, program: program,discount_wage:discountWage[1],discount_part:discountPart[1],
    wage_amount:sumAmtWage,part_amount:sumAmtPart,amount:netTotal,remark:remark, symptomlist:this.state.symptomlist }
    this.saveWorkdocFixingList(postData,(result)=>{
      
      if (result.data.discount_part>0||result.data.discount_wage>0) {
        displayDiscount = ""
        checkDiscount = true
      } else {
        displayDiscount = "none"
        checkDiscount = false
      }
      this.refs.notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'บันทึกข้อมูลเรียบร้อย',
        level: 'info',
        position:'tc'
      });
      this.setState({loading:false,displayDiscount:displayDiscount,checkDiscount:checkDiscount})
      if (completeSaveFunc!==undefined)
        completeSaveFunc('OK')
      
    },(error)=>{
      this.setState({loading:false,errorShow:true})
    })
    
  }

  saveWorkdocFixingList(postData,completeFunc,errorFunc){
    if(this.props.onSaveData!==undefined){
      this.props.onSaveData(postData,completeFunc,errorFunc)
    }else{
      WorkdocStore.saveWorkdocFixingList2(postData,completeFunc,errorFunc)
    }
  }

  onConfirmSave(){
    this.setState({errorShow:false})
    this.onSaveClick()
  }

  onCloseClick(){
    if(this.props.onClose!==undefined){
      this.props.onClose();
    }else if(window.show_work_table!==undefined){
      window.show_work_table();
    }
  }

  onMenuItemSelect(index,event){
    // console.log("eventKey",eventKey,event)
    let {docMenu} = this.state
    let eventKey = docMenu[index].func
    
    let {workNo} = this.props
    if("quotation"===eventKey){
      if(typeof window.request_quotation!=='undefined')
        window.request_quotation();   
      else{
        //Modal
        this.setState({showQOTable:true})
      }    
    }else if("deposit"===eventKey){
        this.onSaveClick((result)=>{
          if (result==='OK')
            this.setState({showDpDoc:true})
        })
    }else if("deliveryslip"===eventKey){
      this.onSaveClick((result)=>{
        if (result==='OK') {
          this.setState({genTitle:'ใบส่งของ/ใบยืมสินค้า',genDocType:'deliveryslip',genDocSName:'ds',genDocName:'deliveryslip_doc'})
          setTimeout(()=>{
            this.setState({showGenDoc:true})
          },100)
        }  
      })
    }else if("tempdeliverynote"===eventKey){
      this.onSaveClick((result)=>{
        if (result==='OK') {
          this.setState({genTitle:'ใบส่งของชั่วคราว',genDocType:'tempdeliverynote',genDocSName:'tdn',genDocName:'tempdeliverynote_doc'})
          setTimeout(()=>{
            this.setState({showGenDoc:true})
          },100)
        }  
      })
    }else if("print_doc1"===eventKey){
      let paramWo = workNo
      if(docMenu[index].wo!==undefined){
        paramWo = docMenu[index].wo
      }
      let url = './pdf?wo=' + paramWo + '&file='+docMenu[index].doc
      if (process.env.NODE_ENV === "development") {
        url = 'https://demo2.bigfix.co/korat/pdf/?wo=' + paramWo + '&file='+docMenu[index].doc
      }
      this.refs.iframe.getWrappedInstance().loadUrl(url) 
    }else if("print_doc"===eventKey){
      let url = './pdf/v2?wo=' + workNo + '&startPage='+docMenu[index].doc
            
      if (process.env.NODE_ENV === "development") {
        url = './?wo=' + workNo + '&startPage=' +docMenu[index].doc    
      }
      
      this.refs.iframe.getWrappedInstance().loadUrl(url) 
    }else if([ "invoice", "receipt", "taxinvoice", "cashbill","makerepairs"].includes(eventKey)){
      //window.request_cash_bill();    
      //this.setState({showNewDoc:true})  
      this.refs.newdoc.getWrappedInstance().loadData({workNo:workNo,docType:eventKey,docName:docNameConst[eventKey],
          onRowClick:function(docNo){
          if (process.env.NODE_ENV === "development") {
            alert('show_cashbill_doc:'+docNo)
          }else{
            //window.show_cashbill_doc(docNo);
            var fn = window['show_'+eventKey+'_doc'];          
            if (typeof fn === 'function') {              
                fn.apply(undefined, [docNo]);
            } 
          }
        },onNewDoc:function(filterType,priceOnListType){
          if (process.env.NODE_ENV === "development") {
            alert('onNewDoc:'+filterType+','+priceOnListType)
          }else{
            var fn = window['create_'+eventKey+'_doc'];          
            if (typeof fn === 'function') {              
                fn.apply(undefined, [workNo,filterType,priceOnListType]);
            }          
          }
        }
      })
    }else if("lock_export"===eventKey){
      this.export_stock(LOCK_EXPORT_CONFIG)  
  
    }else if("exportstock"===eventKey){ 
      // window.request_export_stock();

      this.export_stock(STOCK_OUT_CONFIG)  
    }else if("purchaseorder"===eventKey){
      // window.request_purchase();
      this.setState({showPoDoc:true})
      this.refs.poDocModal.getWrappedInstance().callNewDoc(this.state.dataPartlist,this.props.workNo)
    }
  }

  export_stock(stockOutConfig){
    
    
    WorkdocStore.loadWorkdocFixingList(this.props.workNo,(result)=>{

      let data = []
      for (var i=0;i<result.data.partlist.length;i++) {
        if (result.data.partlist[i].stock_flag === "1") {
          result.data.partlist[i].description = result.data.partlist[i].detail
          data.push(result.data.partlist[i])
        }
      }

      const yTh = (Moment().format('YYYY')*1) + 543
      const date = Moment().format('L LT').replace(Moment().format('YYYY'), yTh);
      let export_stock_flag = []
      data.forEach(element => {
        if (element.export_stock_flag==="1" || element.export_stock_flag==="2") {
          export_stock_flag.push({
            itemnum: element.itemnum
          })
        }
      })
      let displayBtnStockOutView = "none"
      let btnDisabled = false
      if (export_stock_flag.length>0) { // export_stock_flag.length==data.length
        displayBtnStockOutView = "none"
      } 
      if (export_stock_flag.length===data.length) {
        displayBtnStockOutView = "none"
        btnDisabled = true
      }
      this.setState({ createDate:date, showStockOut:true,stockOutConfig:stockOutConfig, dataStockOut:data, displayBtnStockOutView:displayBtnStockOutView, btnDisabled:btnDisabled })  

    },()=>{

    })
  }

  request_makerepairs(eventKey){
        
    let {workNo} = this.props
    let that = this
    //Show table
    this.refs.newdoc.getWrappedInstance().loadData({workNo:workNo,docType:'makerepairs',docName:docNameConst['makerepairs'],
        onRowClick:function(docNo){
          that.setState({showNewDoc:true,docNo:docNo})
      },onNewDoc:function(filterType,priceOnListType){
        //Do something new
        // console.log('onNewDoc',filterType,priceOnListType)
        that.setState({showNewDoc:true})
      }
    })
  }

  onStockOutDeleteClick(e) {
    let data = this.state.dataStockOut
    var key = ""
    for (var i = 0; i < this.state.dataStockOut.length; i++) {
      if (e === this.state.dataStockOut[i].bf_work_damage_id) { // itemnum
        key = i
      }
    }

    data.splice(key, 1)
    this.setState({ dataStockOut: data })
  }

  onStockOutCancelClick(e) {
    
  }  

  onStockOutCloseClick() {
    this.setState({ showStockOut: false })
  }

  onShowWageChange(value){
    this.setState({showWage:value})
  }

  onProgramChange(wageList,partList,program){
    this.setState({program:program})

    let {partFromList,damageCfg} = this.state
    wageList = this.refs.wageDataGrid.getWrappedInstance().setWageList(this.setWageList(wageList))
    if(damageCfg.part_from_list_visible){
      // console.log('program',wageList,partList)
      partFromList[0].partList = this.setPartList(partList)
      this.setState({partFromList:partFromList,loadingPart:false,loading:true})

      setTimeout(()=>{
        this.setState({loadingPart:true,loading:false})
      },500)
      //this.refs['partDataGrid-'+partFromList[0].name].getWrappedInstance().setPartList(this.setPartList(partList))
    }else{
      partList = this.refs.partDataGrid.getWrappedInstance().setPartList(this.setPartList(partList))
    }
    
    let {discountPart,discountWage} = this.state
    this.calculateDiscount(discountPart,discountWage,partList,wageList)
  }

  onProgramDeleteClick() {
    let {program} = this.state
    program.program_id = '0'
    this.setState({program:program})
  }

  onSuccessExport(){
      this.loadData(this.props.workNo)
  }

  onTabSelect(index){
    let {history} = this.state
    if (index==='setting') {
      this.setState({showSetting:true})
    } else {
      this.setState({activeTab:index})

      if (index===history.length-1||index===0) {
        //this.setState({presentTab:index})      
      }

      let item = history[index]
      if(this.props.workNo !== item.work_no && item.htmlContent===''){
        this.setState({loading:true})
        let that = this
        
        WorkdocStore.loadWorkdocFixingListHtmlContent(item.work_no,function(result){
          history[index].htmlContent = result.data.htmlContent
          that.setState({loading:false,history:history})
        })
      }
    }  
  }

  renderDocMenu(){
    let {messages} = this.props
    let {docMenu} = this.state
    let title = (<span><i className="fa  fa-edit"></i>&nbsp;{messages['Create Document']}</span>)
    return (
      <div className="box-tools pull-right">
      <ButtonToolbar>
        <DropdownButton id='split-doc-menu' bsStyle={'primary'} title={title}  onSelect={this.onMenuItemSelect.bind(this)}>
          {
            docMenu.map((item,index)=>(
              
                (item.func==='divider')?
                (<MenuItem key={index} divider />):
                (<MenuItem key={index} eventKey={index}><FontAwsome name='file-text-o' className='text-green'/>{item.title}</MenuItem>)
              
            ))
          }
          
        </DropdownButton>
      </ButtonToolbar>
      </div>
    )
  }

  renderDocMenu2(){
    return (
      <div className="box-tools pull-right">
        <div className="btn-group hide-when-done">
        <button type="button" className="btn btn-primary "><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</button>
        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        <span className="caret"></span>
        <span className="sr-only">Toggle Dropdown</span>
        </button>
        <ul className="dropdown-menu" role="menu">
        <li aria-disabled="true"><a href="#new_doc_quotation"><i className="fa  fa-file-text-o text-green"></i>ใบเสนอราคา</a></li>
        <li aria-disabled="true"><a href="#new_doc_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบแจ้งหนี้</a></li>
        <li aria-disabled="true"><a href="#new_doc_receipt"><i className="fa  fa-file-text-o text-green"></i>ใบเสร็จรับเงิน</a></li>
        <li aria-disabled="true"><a href="#new_doc_tax_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบกำกับภาษี</a></li>
        <li aria-disabled="true"><a href="#new_doc_cash_bill"><i className="fa  fa-file-text-o text-green"></i>บิลเงินสด</a></li>
        <li aria-disabled="true"><a href="#new_doc_export_stock"><i className="fa  fa-file-text-o text-green"></i>ใบเบิกคลังสินค้า</a></li>
        </ul>
        </div>
      </div>
    )
  }
  
  onSelectPartTab(e){
    this.setState({partTab:e})
  }


  onWageDataChange(data){
    this.setState({dataWagelist:data})
    //this.getDiscountWage(data)
    let {discountPart,discountWage,dataPartlist} = this.state
    this.calculateDiscount(discountPart,discountWage,dataPartlist,data,'table')
  }

  onPartFromDataChange(index,data){
    let {partFromList} = this.state
    let partList = []
    partFromList[index].partList = data
    partFromList.map((item,index)=>{
      //partFromList.partList = this.refs['partDataGrid-'+item.name].getWrappedInstance().getPartList(item.name)
      partList =  partList.concat(item.partList)
      return item
    })      
      
    this.setState({partFromList:partFromList})
    //this.getDiscountPart()
    let {discountPart,discountWage,dataWagelist} = this.state
    //this.setState({})
    this.calculateDiscount(discountPart,discountWage,partList,dataWagelist,'table')
  }

  onPartDataChange(data){
    this.setState({dataPartlist:data})
    //this.getDiscountPart(data)
    let {discountPart,discountWage,dataWagelist} = this.state
    this.calculateDiscount(discountPart,discountWage,data,dataWagelist,'table')
  }

  calculateDiscount(disPart,disWage,dataPartlist,dataWagelist,source=''){
    let sumAmtPart=0,sumAmtWage=0,totalBeforeDis=0,totalAfterDis = 0,netTotal=0;
    let discountPart=[0,0],discountWage=[0,0]
    dataPartlist.forEach(function(item,index) {
      let quantity = item.quantity===undefined?0:item.quantity*1
      let pricePerUnit = item.pricePerUnit===undefined?0:item.pricePerUnit*1
      let discountAmount = item.discountAmount===undefined?0:item.discountAmount*1

      sumAmtPart += (quantity*pricePerUnit)
      discountPart[1] += discountAmount      
    })
    dataWagelist.forEach(function(item,index) {
      let quantity = item.quantity===undefined?0:item.quantity*1
      let pricePerUnit = item.pricePerUnit===undefined?0:item.pricePerUnit*1
      let discountAmount = item.discountAmount===undefined?0:item.discountAmount*1

      sumAmtWage += (quantity*pricePerUnit)
      discountWage[1] += discountAmount      
    })
    //console.log('dis',discountPart,discountWage,disPart,disWage)
    if(discountPart[1]>0)
      discountPart[0] = ((discountPart[1]/sumAmtPart)*100).toFixed(2)

    if(discountWage[1]>0)
      discountWage[0] = ((discountWage[1]/sumAmtWage)*100).toFixed(2);

    if(disPart[1]> discountPart[1] && discountPart[1]>0 && source==='sum'){
      //Table more than sum
      this.setState({discountShow:true})
      return false
    }

    if(disWage[1]> discountWage[1] && discountWage[1]>0 && source==='sum'){
      //Table more than sum
      this.setState({discountShow:true})
      return false
    }
    
    if(discountPart[1]===0 && (source==='sum' || source==='init')){
      if(disPart[1]>0){
        discountPart[0] = ((disPart[1]/sumAmtPart)*100).toFixed(2)
        discountPart[1] = disPart[1]  
      }else if(disPart[0]>0){
        discountPart[0] = disPart[0]
        discountPart[1] = sumAmtPart*disPart[0]/100
      } 
    }

    if(discountWage[1]===0  && (source==='sum' || source==='init')){
      if(disWage[1]>0){
        discountWage[0] = ((disWage[1]/sumAmtWage)*100).toFixed(2)
        discountWage[1] = disWage[1]
      }else if(disWage[0]>0){
        discountWage[0] = disWage[0]
        discountWage[1] = sumAmtWage*disWage[0]/100        
      }
    }


    totalBeforeDis = sumAmtPart + sumAmtWage
    totalAfterDis = totalBeforeDis - discountPart[1] - discountWage[1]
    netTotal = totalAfterDis
    this.setState({discountPart:discountPart,discountWage:discountWage,sumAmtPart:sumAmtPart,sumAmtWage:sumAmtWage,totalAfterDis:totalAfterDis,totalBeforeDis:totalBeforeDis,netTotal:netTotal})

    return true
  }

  getNumberFormat(value) {
    if(value===''||value===null||value===undefined||isNaN(value)){
      return ''
    }
    let _val = parseFloat(value)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  checkSumDiscountOpen(dataPartlist,dataWagelist,discountWage,discountPart) {    

    let discountWage_table = 0
    dataWagelist.forEach(function(item,index) {
      let discountAmount = 0
      if (item.discountAmount<=0||isNaN(item.discountAmount)===true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }
      discountWage_table = parseFloat(discountWage_table)+parseFloat(discountAmount)
    })

    let discountPart_table = 0
    dataPartlist.forEach(function(item,index) {
      let discountAmount = 0
      if (item.discountAmount<=0||isNaN(item.discountAmount)===true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }
      discountPart_table = parseFloat(discountPart_table)+parseFloat(discountAmount)
    })
    // console.log('onCheckDiscount',discountWage,discountPart)
    if (discountWage[1]>0 || discountPart[1]>0 || discountWage_table>0||discountPart_table>0) {
      this.setState({checkDiscount:true})
    } else {
      this.setState({checkDiscount:false})
    }
  }

  onDiscountPercentChange(table,e) {
    let {discountPart,discountWage,dataPartlist,dataWagelist} = this.state    
    let disPart = [0,0],disWage =[0,0]
    let val = e.target.value
    if(val.charAt(0)==='0'){
      val = val.substring(1, val.length)
    }
    if (table==='wage') {
      disWage[0] = val
      disWage[1] = ''
      this.calculateDiscount(discountPart,disWage,dataPartlist,dataWagelist,'sum')
    } else if (table==='part') {
      disPart[0] = val
      disPart[1] = ''      
      this.calculateDiscount(disPart,discountWage,dataPartlist,dataWagelist,'sum')
    }    
  }

  onDiscountAmountChange(table,e) {
    let {discountPart,discountWage,dataPartlist,dataWagelist,sumAmtWage,sumAmtPart} = this.state
    let disPart = [0,0],disWage =[0,0]

    if (table==='wage') {
      if (sumAmtWage>0) {
        disWage[0] = ''
        disWage[1] = e.target.value
        this.calculateDiscount(discountPart,disWage,dataPartlist,dataWagelist,'sum')
      }
    } else if (table==='part') {
      if (sumAmtPart>0) {
        disPart[0] = ''
        disPart[1] = e.target.value
        this.calculateDiscount(disPart,discountWage,dataPartlist,dataWagelist,'sum')
      }  
    }
  }


  onCheckDiscountChange(e) {
    let {checkDiscount,displayDiscount,discountPart,discountWage,curDiscountPart,curDiscountWage} = this.state
    if (checkDiscount) {
      checkDiscount = false
      displayDiscount = "none"
      // curDiscountPart = discountPart
      // curDiscountWage = discountWage
      // discountPart = [0,'']
      // discountWage = [0,'']
    } else {
      checkDiscount = true
      displayDiscount = ""
      // discountPart = curDiscountPart
      // discountWage = curDiscountWage
      // discountPart = [0,'']
      // discountWage = [0,'']
    }
    this.setState({checkDiscount:checkDiscount,displayDiscount:displayDiscount,curDiscountPart:curDiscountPart,curDiscountWage:curDiscountWage,discountPart:discountPart,discountWage:discountWage})
  }

  onIconWorkClick(workNo){
    if (process.env.NODE_ENV === "development") {
      alert('show_work_doc:'+workNo)
    }else{
      window.show_work_doc(workNo,'#tab_wd2')
    }
  }

  onPoDocModalHide() {
    this.setState({showPoDoc:false})
  }

  onGenDocClose() {
    this.setState({showGenDoc:false})
  }

  onDepositSelect(item) {
    this.onSaveClick((result)=>{
      if (result==='OK') {
        this.setState({showDocW:true})
        setTimeout(()=>{
          this.refs.dpDocW.getWrappedInstance().loadData(item.deposit_no)
        },100)
      }
    })
  }

  onDepositSaved() {
    this.loadData(this.props.workNo)
  }

  onVatChange(e){
    
    this.setState({vat_type:e.value})
    if(this.props.onVatChange!==undefined){
      this.props.onVatChange(e.value)
    }
  }

  getVatOptions(){
    return [
      {label:'Vat นอก',value:'VAT_EXCLUDE'},
      {label:'Vat ใน',value:'VAT_INCLUDE'},
      {label:'ไม่รวม Vat',value:'NON_VAT'},
    ]
  }

  getTotalBeforeVat(vat_type,amount){
    if(vat_type=='VAT_INCLUDE'){
      return amount /1.07
    }else{
      return amount
    }
  }

  getTotalVat(vat_type,amount){
      if(vat_type=='NON_VAT'){
        return 0
      }else{
        return amount * 0.07
      }
  }

  renderSummary() {
    let {damageCfg,displayDiscount,discountPart,discountWage,sumAmtWage,sumAmtPart,totalBeforeDis,totalAfterDis,netTotal,vat_type,remark} = this.state
    let {messages,showVat,showRemark} = this.props
        
    if(damageCfg.hide_price_on_damage){
      displayDiscount = 'none'
    }
    let totalBeforeVat = this.getTotalBeforeVat(vat_type,totalAfterDis)
    let totalVat = this.getTotalVat(vat_type,totalBeforeVat)
    netTotal = totalBeforeVat + totalVat
    let showVat7 = (vat_type!=='NON_VAT')
    return([
        <Col md={7} key={0}>          
          {showRemark && (<div>
              <ControlLabel>หมายเหตุ</ControlLabel>
              <FormControl 
              value={remark}
              onChange={(e)=>{this.setState({remark:e.target.value})}}
              style={{maxWidth:'500px'}}
              componentClass="textarea" placeholder="ใส่หมายเหตุ" rows="5" maxLength="1024"></FormControl>
            </div>
            )}
        </Col>,        
        <Col md={5} className="" key={1}>
          <div className="">
            <table className='table table-doc-summary'>
                <tbody>
                  <tr style={{display:(showVat?'':'none')}}>
                    <td className="text-right"></td>
                    <td className="text-right"></td>
                    <td  style={{width:'150px'}}>
                      คิดภาษีแบบ
                      <Select placeholder='เลือกชำระภาษีแบบ' clearable={false}
                      value={vat_type} onChange={this.onVatChange.bind(this)} 
                      options={this.getVatOptions()}/>                    
                    </td>
                  </tr>

                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>{messages['Amount Of Wages']}</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(sumAmtWage).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;{messages['Bath']}</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>{messages['Amount Of Parts']}</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(sumAmtPart).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;{messages['Bath']}</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>{messages['Total']}</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(totalBeforeDis).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;{messages['Bath']}</td>
                  </tr>
                  <tr style={{display:displayDiscount}}>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroup.Addon style={{border:'none',color:'#333',fontSize:'16px',paddingLeft:'30px'}}>{messages['Discount Wages']}</InputGroup.Addon>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px',width:'80px'}}
                            type="text" 
                            className='text-right input-right'
                            value={discountWage[0]}
                            onChange={this.onDiscountPercentChange.bind(this,'wage')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>%</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px'}}
                            type="text" 
                            placeholder="x,xxx"
                            className='text-right'
                            value={discountWage[1]}
                            onChange={this.onDiscountAmountChange.bind(this,'wage')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>{messages['Bath']}</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                  </tr>
                  <tr  style={{display:displayDiscount}}>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroup.Addon style={{border:'none',color:'#333',fontSize:'16px',paddingLeft:'30px'}}>{messages['Discount Parts']}</InputGroup.Addon>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px',width:'80px'}}
                            type="text" 
                            className='text-right input-right'
                            value={discountPart[0]}
                            onChange={this.onDiscountPercentChange.bind(this,'part')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>%</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px'}}
                            type="text" 
                            placeholder="x,xxx"
                            className='text-right'
                            value={discountPart[1]}
                            onChange={this.onDiscountAmountChange.bind(this,'part')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>{messages['Bath']}</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                  </tr>
                  <tr  style={{display:displayDiscount}}>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>{messages['Total After Discount']}</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(totalAfterDis).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;{messages['Bath']}</td>
                  </tr>
                  <tr style={{display:(showVat&&showVat7?'':'none')}}>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>{messages['Total Before Vat']}</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(totalBeforeVat).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;{messages['Bath']}</td>
                  </tr>
                  <tr style={{display:(showVat&&showVat7?'':'none')}}>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>{messages['Vat 7%']}</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(totalVat).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;{messages['Bath']}</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="bbr-b text-right" style={{width:'150px'}}><b>{messages['Net Amount']}</b></td>
                    <td className="bbr-b text-right" style={{width:'150px'}}>{parseFloat(netTotal).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;{messages['Bath']}</td>
                  </tr>
                </tbody>
              </table>
          </div>    
        </Col>  
    ])
  }
  
  renderDepositListTable(depositlist) {
    return([
      <Box.Header key={0}>
        <Box.Title><FontAwsome name='money' className='text-green'/>&nbsp;ยอดมัดจำ</Box.Title>
      </Box.Header>,
      <Box.Body key={2}>
        <div className='table-responsive'>
          <table className='table table-responsive table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th style={{width:'200px'}} className='text-center'>วันที่/เวลา</th>
                <th style={{width:'200px'}} className='text-center'>เอกสารเลขที่</th>
                <th style={{width:'200px'}} className='text-center'>มูลค่า</th>
                <th style={{width:'200px'}} className='text-center'>ยอดมัดจำ</th>
              </tr>
            </thead>
            <tbody>
            {depositlist.map((item,index)=>  
              <tr key={index}>
                <td className='text-center'>{item.added_date}</td>
                <td className='text-center'>{item.deposit_no}&nbsp;<Button onClick={this.onDepositSelect.bind(this,item)} bsSize='sm'><FontAwsome name='search' /></Button></td>
                <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
                <td className='text-right'>{this.getNumberFormat(item.deposit_amount)}</td>
              </tr>
            )}  
            </tbody>  
          </table>
        </div>
      </Box.Body>  
    ])
  }

  onSeeMoreOption(index,field) {
    let {see_more} = this.state
    see_more[field].push(index)
    this.setState({see_more:see_more})
  }

  onCloseSeeMoreOption(index,field) {
    let {see_more} = this.state
    let key = see_more[field].indexOf(index)
    if (key!==-1)
      see_more[field].splice(key,1)
    this.setState({see_more:see_more})
  }

  renderSeeMoreItem(items,index,field) {
    let {see_more} = this.state
    return(
      items.map((sitem,sindex)=> {
        if (see_more[field].indexOf(index)!==-1) {
          return(
            <div key={sindex}>
              <div>{sitem.detail} จำนวน : {sitem.quantity}</div>
              {items.length>3&&sindex===items.length-1
              ?
              <Button
                bsStyle={'link'}
                style={{padding:'0'}}
                onClick={this.onCloseSeeMoreOption.bind(this,index,field)}
              >
                ซ่อนดูเพิ่มเติม...
              </Button>
              :''}
            </div>
          )
        } else {
          if (sindex<3) {
            return(
              <div key={sindex}>
                <div>{sitem.detail} จำนวน : {sitem.quantity}</div>
                {items.length>3&&sindex===2
                ?
                <Button
                  bsStyle={'link'}
                  style={{padding:'0'}}
                  onClick={this.onSeeMoreOption.bind(this,index,field)}
                >
                  ดูเพิ่มเติม...
                </Button>
                :''}
              </div>
            )
          } else {
            return('')
          }
        }  
      })
    )
  }

  renderRowDataPromotion() {
    let {promotionlist} = this.state
    return(
      promotionlist.map((item,index)=>{
            return(
              <tr key={index}>
                <td className='text-center'>{index+1}</td>
                <td className='text-center'>{item.program_name}</td>
                <td className='text-right'>{this.getNumberFormat(item.price)}</td>
                <td className=''>
                  {this.renderSeeMoreItem(item.partlist,index,'partlist')}
                </td>
                <td className=''>
                  {this.renderSeeMoreItem(item.wagelist,index,'wagelist')}
                </td>
                <td className='text-center'><Button><FontAwsome name='shopping-cart' />&nbsp;เลือกโปรโมชั่น</Button></td>
              </tr>
            )
      }) 
    )       
  }          

  renderPromotionTable() {
    return([
      <Box.Header key={0}>
        <Box.Title><FontAwsome name='bullhorn' className='text-yellow'/>&nbsp;พบโปรโมชั่น/แพ็กเกจ</Box.Title>
      </Box.Header>,
      <Box.Body key={2}>
        <div className='table-responsive'>
          <table className='table table-responsive table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th rowSpan={2} style={{width:'50px'}} className='text-center'>ลำดับ</th>
                <th rowSpan={2} style={{width:'150px'}} className='text-center'>ชื่อ โปรโมชั่น</th>
                <th rowSpan={2} style={{width:'100px'}} className='text-center'>ราคา</th>
                <th colSpan={2} className='text-center'>รายละเอียด</th>
                <th rowSpan={2} style={{width:'80px'}} className='text-center'>เลือก</th>
              </tr>
              <tr>
                <th style={{width:'75px'}} className='text-center'>รายการอะไหล่</th>
                <th style={{width:'75px'}} className='text-center'>รายการค่าแรง/บริการ</th>
              </tr>  
            </thead>
            <tbody>
              {this.renderRowDataPromotion()}
            </tbody>  
          </table>
        </div>
      </Box.Body>  
    ])
  }

  renderPresentWork(){
    let {loading,damageCfg,checkDiscount,depositlist,promotionlist} = this.state
    let {messages,config} = this.props
    let showDiscountChecbox = damageCfg.discount_sum_visible
    if(damageCfg.hide_price_on_damage){
      showDiscountChecbox = false
    }
    return (        
      <Box loading={loading}>
        {depositlist.length>0&&config.deposit?this.renderDepositListTable(depositlist):''}
        {promotionlist.length>0?this.renderPromotionTable():''}
        <Box.Header>
          <Box.Title><FontAwsome name='warning' className='text-blue'/>&nbsp;{messages['Repair/Replacement']}</Box.Title>
          {config.createBtn?this.renderPresentWorkDocMenu():''}
          {this.props.renderCustomMenu!==undefined?this.props.renderCustomMenu():''}
        </Box.Header>
        {this.renderPresentWorkBody()}        
        <Box.Footer>
          <div className='pull-right'>
                <div style={{display:(showDiscountChecbox)?'inline-block':'none'}}>
                      <Checkbox
                        onChange={this.onCheckDiscountChange.bind(this)}
                        checked={checkDiscount}
                        checkboxClass="icheckbox_square-blue"
                        increaseArea="20%"
                        label={' '+messages['Discount']}
                      >
                      </Checkbox>
              </div>
                      &nbsp;
              <Button bsStyle={'primary'} 
                className='hide-when-done element-ready'
                onClick={this.onConfirmSave.bind(this)}
              >
                <FontAwsome name='save'/>&nbsp;{messages['Save']}
              </Button>
              &nbsp;
              <Button onClick={this.onCloseClick.bind(this)}><FontAwsome name='close'/>&nbsp;{messages['Close Worksheet']}</Button>            
          </div> 
        </Box.Footer>
      </Box>
    )
  }

  renderPresentWorkDocMenu() {
    let {presentTab,history} = this.state
    // console.log("length-1",history.length-1)
    // console.log("presentTab",presentTab)
    if (presentTab!==history.length-1) {
      return (
        this.renderDocMenu()
      )  
    }  
  }

  renderWageTable(){
    let {showWage,program,damageCfg,loadingPart,dataWagelist} = this.state
    let {messages} = this.props
    let pgmName = ''
    if (program!==undefined) {
      pgmName = (program!==null && program.name!==null && program.program_id>0)?messages['Program']+program.name:''
    }
    return (
      <Row>
        <Col md={12}>
            <div>
              <h4 className='text-center'><span style={{display:showWage?'inline-block':'none'}}>{messages['Summary Of Wages']} {pgmName}</span>
                <div className='pull-right'>
                  <Checkbox 
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' '+messages['Hide Wages']}
                    checked={!showWage}
                    onChange={this.onShowWageChange.bind(this,!showWage)}
                  />
                </div>
              </h4>
            </div>
            <div style={{display:showWage?'block':'none'}}>
              <SWTWageDataGrid 
                ref={'wageDataGrid'} 
                show={loadingPart}
                workNo={this.props.workNo}
                wageList={dataWagelist}
                initNoOfRow={damageCfg.init_no_of_wage}                
                showServiceCode={damageCfg.service_code_visible} 
                showDiscount={damageCfg.discount_visible}
                showQuantity={damageCfg.wage_quantity_visible} 
                showProgramButton={damageCfg.program_visible} 
                hidePriceOnDamage={damageCfg.hide_price_on_damage}
                onProgramChange={this.onProgramChange.bind(this)}
                onProgramDeleteClick={this.onProgramDeleteClick.bind(this)}
                onChange={this.onWageDataChange.bind(this)}
              />
            </div>
        </Col>    
      </Row>
    )
  }

  renderOtherPartTab(){
    let {damageCfg,partFromList,partTab,loadingPart} = this.state
    //console.log('partListChange',partFromList,partTab)
    return partFromList.map((item,index)=>(
              <Tab  
                key={index}
                eventKey={'tab-'+item.name}
                title={item.title}
              >
                <SWTPartDataGrid 
                  ref={'partDataGrid-'+item.name}    
                  show={loadingPart && partTab==='tab-'+item.name}    
                  name={item.name}                       
                  partList={item.partList}
                  initNoOfRow={damageCfg.init_no_of_part}
                  showDiscount={damageCfg.discount_visible}
                  showCostPerUnit={damageCfg.part_cost_per_unit_visible}
                  partCostRequire={damageCfg.part_cost_require}
                  hidePriceOnDamage={damageCfg.hide_price_on_damage}
                  onChange={this.onPartFromDataChange.bind(this,index)}
                />
              </Tab>
    ))
  }

  renderPartTable(){
    let {loadingPart,program,damageCfg,partFromList,dataPartlist} = this.state
    let {messages} = this.props
    let pgmName = ''
    if (program!==undefined)
      pgmName = (program!==null && program.name!==null && program.program_id>0)?messages['Program']+program.name:''

    if(damageCfg.part_from_list_visible && partFromList.length>0){
      return (
        
        <div>
          <h4 className='text-center'>{messages['Summary Of Parts']} {pgmName}</h4>
            <Tabs 
              defaultActiveKey={'tab-'+partFromList[0].name} 
              animation={false} 
              id="noanim-tab-example"
              onSelect={this.onSelectPartTab.bind(this)}
            >                          
                {this.renderOtherPartTab()}                
              </Tabs>
              
        </div>
      )
    }else{
      return (
          <Row>
            <Col md={12}>
              <h4 className='text-center'>{messages['Summary Of Parts']} {pgmName}</h4>
              <SWTPartDataGrid 
                ref={'partDataGrid'}  
                name='partDataGrid' 
                show={loadingPart}               
                partList={dataPartlist}     
                initNoOfRow={damageCfg.init_no_of_part}         
                showDiscount={damageCfg.discount_visible}
                showCostPerUnit={damageCfg.part_cost_per_unit_visible}
                partCostRequire={damageCfg.part_cost_require}
                hidePriceOnDamage={damageCfg.hide_price_on_damage}
                onChange={this.onPartDataChange.bind(this)}
              />
            </Col>
        </Row>  
      )
    }
  }

  newSymptomEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {seq:'',added_by:'',added_date:'',bf_symptom_id:'',detail:'',level:'',category:'',category_id:'',remark:'',work_no:this.props.workNo}
    })
  }

  onSymptomDeleteRowClick(index){
    let {symptomlist} = this.state
    symptomlist.splice(index,1);  
    this.setState({symptomlist:symptomlist})
  }

  onSymptomRowAdd(number){
    let {symptomlist} = this.state
    symptomlist = symptomlist.concat(this.newSymptomEmptyRow(number))
    this.setState({symptomlist:symptomlist})
  }

  onSymptomFormChange(index,field,e) {
    let {symptomlist} = this.state
    symptomlist[index][field] = e.target.value
    this.setState({symptomlist:symptomlist})
  }

  onSymptomCategoryChange(index,e) {
    let {symptomlist} = this.state
    if (e!==null) {
      symptomlist[index].category_id = e.value
      symptomlist[index].category = e.label
    } else {
      symptomlist[index].category_id = ''
      symptomlist[index].category = ''
    }
    this.setState({symptomlist:symptomlist})
  }

  onUpdateCategory(newOptions) {
    
  }

  renderSymptomRowData() {
    let {symptomlist} = this.state
    if (symptomlist.length===0) {
      return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        symptomlist.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-left'>
                <Select
                  placeholder='เลือก'
                  value={item.category_id}
                  options={this.state.categorys}
                  onChange={this.onSymptomCategoryChange.bind(this,index)}
                />
              </td>
              <td className='text-left'><FormControl onChange={this.onSymptomFormChange.bind(this,index,'detail')} value={item.detail} /></td>
              <td className='text-center'><FormControl onChange={this.onSymptomFormChange.bind(this,index,'level')} value={item.level} /></td>
              <td className='text-center'>
                <Button onClick={this.onSymptomDeleteRowClick.bind(this,index)} bsStyle='danger'><FontAwsome name='trash' /></Button>
              </td>
            </tr>
          )
        })
      )
    }  
  }

  renderSymptomTable() {
    return(
      <div>
        <h4 className='text-center'>ตรวจเช็คอาการ</h4>
        <div className='table-symptom'>
          <table className='table table-hover table-bordered-solid' style={{marginBottom:'0'}}>
            <thead>
              <tr>
                <th style={{width:'50px'}} className='text-center'>ลำดับ</th>
                <th style={{width:'150px'}} className='text-center'>หมวดหมู่ <FontAwsome onClick={()=>{this.setState({showCate:true})}} style={{cursor:'pointer'}} name='plus' /></th>
                <th style={{width:'300px'}} className='text-center'>รายละเอียดอาการ</th>
                <th style={{width:'70px'}} className='text-center'>ระดับความแรง</th>
                <th style={{width:'50px'}} className='text-center'>ลบ ?</th>
              </tr>
            </thead>
            <tbody>
              {this.renderSymptomRowData()}
            </tbody>
          </table>
        </div>
        {this.renderSymptomNewItemButton()}
      </div>
    )
  }

  renderSymptomNewItemButton(){
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <div className='new-item-btn' style={{display:'inline-flex'}}>
            <Button className='bg-olive' onClick={this.onSymptomRowAdd.bind(this,1)}><FontAwsome name='plus'/>&nbsp;เพิิ่มรายการ</Button>&nbsp;
            <Button className='bg-olive' onClick={this.onSymptomRowAdd.bind(this,10)}><FontAwsome name='plus'/>&nbsp;เพิิ่ม 10 รายการ</Button>
          </div>        
        </Col>
      </Row>
    )
  }

  renderCategoryModal() {
    let {showCate,categorys} = this.state
    return(
      <div>
        <WorkDocCategoryModal
          show={showCate}
          onHide={()=>{this.setState({showCate:false})}}
          categorys={categorys}
          onUpdateCategory={this.onUpdateCategory.bind(this)}
        />
      </div>
    )
  }

  renderPresentWorkBody() {
    let {damageCfg} = this.state
    // let {messages} = this.props
    // let pgmName = ''
    // if (program!==undefined)
    //   pgmName = (program!==null && program.name!==null)?messages['Program']+program.name:''

    let displayDiscount = this.state.displayDiscount
    if(damageCfg.hide_price_on_damage){
      displayDiscount = 'none'
    }

    if (damageCfg.part_first) {
      return(
          <Box.Body>
            {this.renderSymptomTable()}
            {this.renderPartTable()}
            {this.renderWageTable()}
            <Row >
              {this.renderSummary()}
            </Row>
            
          </Box.Body>
      )
    } else {
      return(
          <Box.Body>
            {this.renderSymptomTable()}
            {this.renderWageTable()}
            {this.renderPartTable()}
            <Row >
              {this.renderSummary()}
            </Row>
          </Box.Body>
      )
    }  
  }

  renderPastWork(){
    let {history,activeTab,presentTab,loading} = this.state
    let {messages} = this.props
    let item = history[activeTab]
    if(presentTab!==activeTab){
    return (
      <Box loading={loading}>
        <Box.Header>
          <Box.Title><FontAwsome name='warning' className='text-blue'/>&nbsp;{messages['Number Km.']} {item.mileage} {messages['Repair Item']}</Box.Title>          
        </Box.Header>
        <Box.Body>
          <Button bsStyle='warning' onClick={this.onIconWorkClick.bind(this,item.work_no)}><FontAwsome name='wrench'/> เลขงานซ่อม {item.work_no}</Button>
          <div>
            <Panel style={{marginBottom:'0px'}}><div dangerouslySetInnerHTML={{__html:history[activeTab].htmlContent}}></div></Panel>
          </div>        
        </Box.Body>
      </Box>
    )  
    }else{
      return (<div/>)
    }  
    
  }

  renderNavItem(item,index){
    let {messages} = this.props
    if(item.work_no===this.props.workNo){
      return (<NavItem key={index} eventKey={index} >{messages['This Work Item']}</NavItem>)
    }else{
      return (<NavItem key={index} eventKey={index} >{item.work_date}</NavItem>)
    }
  }

  renderHistoryTab(history){
    let {activeTab} = this.state
    return (
      <Nav bsStyle="tabs" activeKey={activeTab} onSelect={this.onTabSelect.bind(this)}>   
        <NavItem key={history.length-1} eventKey={history.length-1} style={{display:'none'}}>{this.props.messages['Repair In Advance']}</NavItem>     
        {history.map((item,index)=>(
          this.renderNavItem(item,index)
        ))}
        <NavItem style={{float:'right'}} key={'setting'} eventKey={'setting'}><FontAwsome name='gear' /></NavItem>
      </Nav>
    )
  }


  render(){
    let {history,showDpDoc,showPoDoc,stockOutConfig,showMissPartCost,errorShow,activeTab,presentTab,discountShow,showGenDoc,showDocW} = this.state
    return(
      <div>
        <div style={{display:(history.length>0)?'block':'none'}}>
          {this.renderHistoryTab(history)}
        </div>
        <div style={{display:(activeTab===presentTab)?'block':'none'}}>
          {this.renderPresentWork()}
        </div>
        <div style={{display:(activeTab!==presentTab)?'block':'none'}}>
          {this.renderPastWork()}
        </div>        
        <PurchaseOrderNewDocModal 
          ref='poDocModal' 
          show={showPoDoc}
          onHide={this.onPoDocModalHide.bind(this)}
        />
        <SWTStockOutPopup
          stockType={'genpart'}
          config={stockOutConfig}
          onShow={this.state.showStockOut}
          onHide={this.onStockOutCloseClick.bind(this)}
          onDelete={this.onStockOutDeleteClick.bind(this)}
          onCancel={this.onStockOutCancelClick.bind(this)}
          onSuccessExport={this.onSuccessExport.bind(this)}
          data={this.state.dataStockOut}
          date={this.state.createDate}
          workNo={this.props.workNo}
          displayBtnStockOutView={this.state.displayBtnStockOutView}
          btnDisabled={this.state.btnDisabled}
        />          
        <NewDocFormModal ref='newdoc'                             
        />                
        <NotificationSystem ref="notificationSystem" />
        <IframeModal ref='iframe'  title={'พิมพ์เอกสาร'} />
        <ConfirmPopup show={errorShow} 
        title='มีปัญหาในการบันทึกข้อมูล' 
        message='พบปัญหาอินเตอร์เน็ต ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่'
        confirmTitle='ลองใหม่อีกครั้ง'
        onConfirm={this.onConfirmSave.bind(this)}
        onHide={()=>{this.setState({errorShow:false})}}        
        />
        <ConfirmPopup show={discountShow} 
        title='แจ้งเตือน'
        message='ท่านได้ใส่ข้อมูลส่วนลดค่าแรงในตาราง เรียบร้อยแล้ว ถ้าต้องการแก้ไขข้อมูล ให้ลบส่วนลดในตาราง'
        onHide={()=>{this.setState({discountShow:false})}}        
        />
        <ConfirmPopup show={showMissPartCost} 
        title='แจ้งเตือน'
        message='ระบบไม่อนุญาติให้บันทึกข้อมูล ถ้าไม่ได้ใส่ข้อมูลต้นทุนอะไหล่'
        onHide={()=>{this.setState({showMissPartCost:false})}}        
        />
        <ConfigFixingListModal
          show={this.state.showSetting}
          onHide={()=>{this.setState({showSetting:false})}}
        />
        {this.renderCategoryModal()}    
      </div>
    )
  }
}

SWTWorkDocDamage.defaultProps = {
  isProgramMode:false,
  config:{
    deposit:true,
    createBtn:true
  },
  showVat:false,
  showRemark:false
}

// export default SWTWorkDocDamage = connect(
//   (state) => ({messages: state.message.view.workdoc.SWTWorkDocDamage}),null,null,{withRef:true}
// )(SWTWorkDocDamage);

const _Connect = compose(connect(
  (state) => ({messages: state.message.view.workdoc.SWTWorkDocDamage}),null,null,{withRef:true}
))(SWTWorkDocDamage);

export default withRouter(_Connect)



// WEBPACK FOOTER //
// ./src/view/workdoc/fast/SWTWorkDocDamage.js